import { render, staticRenderFns } from "./PackageDescriptorAuthList.vue?vue&type=template&id=852a6402&"
import script from "./PackageDescriptorAuthList.vue?vue&type=script&lang=js&"
export * from "./PackageDescriptorAuthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports